<template>
    <FormularioCadastro :autenticado="true" />
</template>

<script>
import FormularioCadastro from './FormularioCadastro.vue';

export default {
    name: 'GuicheCadastro',
    components: { FormularioCadastro },
};
</script>
